<template>
  <div class="w-full">
    <vs-card
      id="compliance-donut-loading"
      class="vs-con-loading__container px-2 widget-card altura"
      style="position: relative"
    >
      <div @click="filterFullTable">
        <vs-row>
          <vs-col>
            <char-header :title="$t('compliance_by_status')"></char-header>
          </vs-col>
        </vs-row>
      </div>

      <vs-row>
        <vs-col>
          <div class="body-card-widget">
            <vue-apex-charts
              class=""
              type="donut"
              height="250%"
              style="margin-bottom: 10% !important; position: static !important"
              :options="chartOptions"
              :series="series"
              @dataPointSelection="filterTable"
            />
          </div>
        </vs-col>
      </vs-row>
    </vs-card>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import CharHeader from '../components/CharHeader.vue'
//requests
import request from '@/http/requests/dashboard'
//mixins
import loading from '@/mixins/Loading.js'

export default {
  mixins: [loading],
  props:{
    refresh:{
      type:Boolean,
      default:false,
    }
  },
  components: {
    VueApexCharts,
    CharHeader,
  },
  computed: {
    isLoading() {
      return this.loading.compliance_donut
    },
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading('compliance-donut-loading')
      } else {
        this.closeLoading('compliance-donut-loading')
      }
    },
  },
  data() {
    return {
      loading: {
        compliance_donut: false,
      },
      series: [],
      chartOptions: {
        labels: [],
        legend: {
          show: false,
        },
        dataLabels: {
          enabled: false,
        },
        plotOptions: {
          pie: {
            expandOnClick: false,
            donut: {
              labels: {
                show: true,
                total: {
                  show: true,
                  showAlways: true,
                  formatter: function (w) {
                    let total = 0
                    let number
                    let numberOut = 0
                    w.globals.seriesTotals.forEach((element) => {
                      total = total + parseInt(element)
                    })
                    let indice =
                      w.globals.seriesNames.indexOf('Not in Compliance')

                    number = total - parseInt(w.globals.seriesTotals[indice])
                    if (number != NaN) {
                      numberOut = Math.round((number * 100) / total)
                    }
                    if (indice == -1) numberOut = 100
                    return numberOut + '%'
                  },
                },
                name: {
                  show: false,
                },
                value: {
                  show: true,
                  fontSize: '30px',
                },
              },
            },
          },
        },
        chart: {
          id: 'donut-compliance',
        },
        tooltip: {
          enabled: true,
          fillSeriesColor: false,
          marker: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
      },
      complianceData: [],
      colors: [],
      dataTable: null,
    }
  },
  mounted() {
    this.getInfo()
    if(this.refresh === true){
      var v = this
      setInterval(function () {
        v.getInfo()
      }, process.env.VUE_APP_CHART_RELOAD_TIME)
    }
  },
  methods: {
    getInfo() {
      this.loading.compliance_donut = true
      request
        .complianceDonut()
        .then((res) => {
          this.complianceData = res.data.data
          this.fillChartData(this.complianceData)
        })
        .catch((err) => {
          console.log(err)
          this.loading.compliance_donut = false
        })
    },
    fillChartData(dataToChart) {
      if (this.complianceData.length == 0) {
        this.series = [1]
        this.chartOptions.labels = ['NO INFO']
        this.colors = ['#626262']
        this.resertDonut()
      } else {
        for (let i = 0; i < this.complianceData.length; i++) {
          this.chartOptions.labels[i] = this.complianceData[i].status_name
          this.series[i] = parseInt(this.complianceData[i].amount)
          this.colors[i] = this.complianceData[i].status_color
        }
        this.restartDonut()
      }
    },
    restartDonut() {
      ApexCharts.exec(
        'donut-compliance',
        'updateOptions',
        {
          fill: {
            colors: this.colors,
          },
          labels: this.chartOptions.labels,
          series: this.series,
        },
        false,
        true
      )
      this.loading.compliance_donut = false
    },
    countByState(data, state) {
      let count = 0
      data.forEach((element) => {
        if (element.status_name === state) {
          count++
        }
      })
      return count
    },
    filterTable(event, chartContext, config) {
      this.dataTable = this.complianceData.find(
        (el) => el.status_name === config.w.config.labels[config.dataPointIndex]
      )
      this.$emit('click', { statusId: this.dataTable.status_id })
    },
    filterFullTable() {
      this.$emit('click', { statusId: null })
    },
  },
}
</script>
<style>
</style>